import type { TipJarData, WebTheme } from '@shared/dream-components';

import type { GoogleFontEntryType } from '~/services/fonts/cache';

/** Empty while the page matches the site. */
export type TipJarTheme = Partial<
  Pick<
    WebTheme,
    | 'primary_color'
    | 'text_on_primary_color'
    | 'background_color'
    | 'text_on_background_color'
    | 'subscribe_background_color'
    | 'text_on_subscribe_background_color'
    | 'header_font'
    | 'body_font'
    | 'button_font'
    | 'border_radius'
  >
>;

export type TipJarPageData = TipJarData & { theme?: TipJarTheme };

export type TipJarLoaderData = {
  tipJarPage: true;
  tipJar: TipJarPageData;
  pageUrl: string;
  pageTitle: string;
  pageDescription: string;
  initialAmountCents?: number;
  renderableFontsCss: GoogleFontEntryType[];
  adobeFontUrls: string[];
};

export const isTipJarLoaderData = (data: unknown): data is TipJarLoaderData =>
  typeof data === 'object' && data !== null && (data as TipJarLoaderData).tipJarPage === true;
